import { CardProps } from '@procore/core-react/dist/_typedoc/Card/Card.types.json';
import * as React from 'react';
export default {
  CardProps,
  React
};